import SEO from '../../components/SEO/SEO'
import Hero from '../../components/Hero/Hero'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import Filter from './components/Filters/Filter'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { useEffect, useMemo, useState } from 'react'
import { getIndicatorIndex } from '../../redux/slices/indicatorIndex/indicatorIndexThunk'
import { LETTERS } from '../../utils/const'
import Mapper from './components/Indicators/Mapper'
import { useEnsureValidPeriod } from '../../hooks/useEnsureValidPeriod'
import ContactSection from '../../components/Common/ContactSection'
import Loading from '../../components/Loading/Loading'
import useUrlParams from '../../hooks/useUrlParams'

const Index = () => {
    const dispatch = useAppDispatch();
    const { getParam, updateParams } = useUrlParams();

    const { indicatorIndex, loading } = useAppSelector((state) => state.indicator_index);
    const { periods, lastPeriod } = useAppSelector((state) => state.periods);

    const [selectedLetter, setSelectedLetter] = useState<string | null>(null);

    useEffect(() => {
        if (!indicatorIndex) {
            dispatch(getIndicatorIndex());
        }
    }, [indicatorIndex]);

    const activeLetters = useMemo(() => {
        if (!indicatorIndex) return new Set<string>();

        return new Set(
            Object.entries(indicatorIndex)
                .filter(([_, types]) =>
                    Object.values(types).some(arr => arr.length > 0)
                )
                .map(([letter]) => letter)
        );
    }, [indicatorIndex]);

    useEffect(() => {
        if (!indicatorIndex || activeLetters.size === 0) return;

        const paramLetter = getParam('letter');
        const validParamLetter = paramLetter && activeLetters.has(paramLetter) ? paramLetter : null;

        const firstActiveLetter = LETTERS.find((letter) => activeLetters.has(letter)) ?? null;

        setSelectedLetter(validParamLetter ?? firstActiveLetter);
    }, [indicatorIndex, activeLetters, getParam]);

    useEnsureValidPeriod(periods, lastPeriod);

    const currentIndicators = selectedLetter ? indicatorIndex?.[selectedLetter] : null;

    const handleClickLetter = (letter: string) => {
        if (!letter.length) return;

        setSelectedLetter(letter);
        updateParams({ 'letter': letter })
    }

    return (
        <>
            <SEO
                title='Índice de indicadores'
                description='Índice de indicadores'
                type='article'
            />
            <Hero
                breadcrumbs={<Breadcrumbs />}
                title='Índice de indicadores'
                paragraph={"Listado de todos los indicadores ordenados alfabéticamente"}
                media={{ type: '', src: '', url: '', alt: '', className: '' }}
                layout='row'
                backgroundClassName={{ backgroundColor: '#E3DDD8' }}
                containerHeightClassName='h-[23.75rem] sm:h-[21.25rem]'
                titleClassName='text-brand-green-20'
            />
            <section id='indicators-index' className='relative top-[-6.5rem] mt-12 flex justify-center items-center flex-col'>
                <Filter
                    activeLetters={activeLetters}
                    selectedLetter={selectedLetter}
                    onSelect={handleClickLetter}
                />
                {loading === 'succeeded'
                    ? (<Mapper
                        currentIndicators={currentIndicators ?? null}
                        selectedLetter={selectedLetter ?? ""}
                    />)
                    : <div className='mt-10 flex-1 w-full flex items-center justify-center'>
                        <Loading size={40} />
                    </div>
                }
            </section>
            <ContactSection />
        </>
    )
}

export default Index